<template>
  <qx-card-form title="发票信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <section slot="invoiceNumber" slot-scope="prop">
        <section
          class="invoiceNumberBox"
          v-for="(item, index) in prop.form.invoiceNumber"
          :key="item.key"
        >
          <el-input class="inputBox" v-model="item.num" />
          <span class="invoiceNumberBtn primary cur" @click="addInvoiceNumber(index)">添加</span>
          <span class="invoiceNumberBtn error cur" @click="delInvoiceNumber(index)" v-if="prop.form.invoiceNumber.length !== 1">删除</span>
        </section>
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      baseForm: {
        form: [
          {
            label: '发票号码',
            value: 'invoiceNumber',
            default: [{
              num: '',
              key: Symbol('invoiceNumber'),
            }],
            slot: true,
          },
          {
            label: '快递公司',
            value: 'expressCompany',
            type: 'input',
          },
          {
            label: '快递单号',
            value: 'expressNumber',
            type: 'input',
          },
        ],
        rules: {
          invoiceNumber: [ // 发票号码
            { required: true, message: '请输入发票号码', trigger: 'blur' },
          ],
          expressCompany: [ // 快递公司
            { required: true, message: '请输入快递公司', trigger: 'blur' },
          ],
          expressNumber: [ // 快递单号
            { required: true, message: '请输入快递单号', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    addInvoiceNumber (index) {
      const invoiceNumber = this.$refs.baseForm.getVal('invoiceNumber');
      invoiceNumber.splice(index + 1, 0, {
        num: '',
        key: Symbol('invoiceNumber'),
      });
      this.$refs.baseForm.setVal('invoiceNumber', invoiceNumber);
    },
    delInvoiceNumber (index) {
      const invoiceNumber = this.$refs.baseForm.getVal('invoiceNumber');
      invoiceNumber.splice(index, 1);
      this.$refs.baseForm.setVal('invoiceNumber', invoiceNumber);
    },
    async sub () {
      const formData = await this.$refs.baseForm.sub();
      if (formData) {
        formData.invoiceNumber = formData.invoiceNumber.map((item) => item.num);
        formData.invoiceNumber = formData.invoiceNumber.join(',');
      }
      return formData;
    },
    async cacheData () {
      const res = await this.$refs.baseForm.getVal();
      res.invoiceNumber = res.invoiceNumber.map((item) => item.num);
      res.invoiceNumber = res.invoiceNumber.join(',');
      return res;
    },
    async init (data = {}) {
      if (data.invoiceNumber) {
        data.invoiceNumber = data.invoiceNumber.split(',').map((num) => ({
          num,
          key: Symbol('invoiceNumber'),
        }));
      } else {
        data.invoiceNumber = [{
          num: '',
          key: Symbol('invoiceNumber'),
        }];
      }
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
.invoiceNumberBox{
  margin-bottom: 16px;
  .invoiceNumberBtn{
    margin-left: 16px;
  }
}
</style>
